import React from 'react'

import type { MenuPreferences } from '@library/api-menu-experience'
import type { Recipe } from '@library/menu-service'

import { getRecipeSubtitleItems } from './getRecipeSubtitleItems'
import { RecipeSubtitleItems } from './RecipeSubtitleItems'

type RecipeSubtitleProps = {
  recipe: Recipe
  menuPreferences?: MenuPreferences
  numPortions: number
}

export const RecipeSubtitle = ({ recipe, menuPreferences, numPortions }: RecipeSubtitleProps) => {
  const items = getRecipeSubtitleItems({ recipe, menuPreferences, numPortions })

  if (!items.length) {
    return null
  }

  return <RecipeSubtitleItems items={items} />
}
